
import { FormattedMessage } from 'react-intl';

import { ICar } from '@share/common-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  car: ICar;
}

export function CarsCardRefundability(props: IProps) {

  const { car } = props;
  const { refundable } = car;

  return (
    <div className="hotel-card-wrapper__refundable cars-content" style={{ maxWidth: '160px' }}>
      {refundable && (
        <div className="hotel-card-wrapper__refundable-ref">
          <FontAwesomeIcon icon={faCheck} /><FormattedMessage id="refundable" />
        </div>)}
      {!refundable && (
        <div className="hotel-card-wrapper__refundable-nonref">
          <FontAwesomeIcon icon={faTimes} /><FormattedMessage id="non.refundable" />
        </div>)}
    </div>
  );
}
